import {
  React,
  Component,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  FilterMatrix,
} from 'imports/ComponentsImports';

import {
  Paper,
  Divider,
  CircularProgress
} from 'material-ui';

import {
  CircleIcon,
  TwoIcon
} from 'imports/IconsImports';

const styles = {
  listItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    color: '#212F55',
    fontFamily: 'Lato',
    marginBottom: '1em'
  },
  number: {
    border: '1px solid #212F55',
    borderRadius: '25px',
    padding: '0.3em',
    height: '1em',
    width: '1em',
    maxWidth: '1em',
    textAlign: 'center',
    flex: 1
  },
  selectedNumber: {
    border: '1px solid #212F55',
    borderRadius: '25px',
    padding: '0.3em',
    height: '1em',
    width: '1em',
    maxWidth: '1em',
    textAlign: 'center',
    backgroundColor: '#212F55',
    color: 'white',
    flex: 1
  },
  question: {
    textAlign: 'left',
    paddingLeft: '1em',
    display: 'flex'
  },
  questionText: {
    margin: '0.5em 0',
    fontWeight: 'bold'
  },
  state:{
    flex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingRight: '6em',
  },
  tutorialContainer: {
    display: 'flex',
    padding: '1.5em',
    margin: '1.5em',
    color: '#212F55',
    fontFamily: 'Lato',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#FBFBFB',
  },
  listItemContainer: {
    margin: '1.5em',
    backgroundColor: '#FBFBFB',
  },
  tutorialTitle: {
    marginLeft: '20px'
  },
  tutorialParagraph: {
    marginLeft: '1.5em'
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 12
  },
  explanation: {
    fontFamily: 'Lato',
    marginTop:'0em',
    color: '#212F55',
    fontSize: '0.8em',
    paddingLeft: '2em'
  },
  subTitle: {
    marginTop: '0',
    marginBottom: '2em',
    paddingLeft: '2em',
  }
}

class Criterias extends Component {
  constructor(props){
    super(props);
    this.state = {
      selected: 0,
      matrixData: null,
      matrixCompleted: false,
      filterCompleted: false,
      error: false,
      loading: true,
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
    }
  }

  componentDidMount(){
    this.getData();
  }

  render() {
    return (
      <Paper zDepth={1} style={styles.listItemContainer}>
        <div style={styles.listItem}>
          <div style={styles.titleContainer}>
            <div style={styles.question}>
              <h3 style={styles.questionText}><TwoIcon /> ¿Cuáles son los criterios que debe cumplir una iniciativa para ser denominada de innovación?</h3>
              {this.state.matrixCompleted ?
                <div style={styles.state}>
                  <CircleIcon style={{color:'#11AB99'}}/><div>Completado</div>
                </div> :
                <div style={styles.state}>
                <CircleIcon style={{color: '#FF952B'}}/><div>Pendiente</div>
                </div>
              }
            </div>
            <p style={styles.subTitle}>El propósito de los criterios es definir características mínimas que debe cumplir cada proyecto para ser considerado innovación.</p>
          </div>
        </div>
        <Divider/>
        {this.state.error===false && this.state.loading===false ?
          <FilterMatrix key={1} send={this.props.send} done={this.props.done} history={this.props.history} choices={this.state.choices} data={this.state.matrixData} addMatrixData={this.addMatrixData} complete={() => this.setState({matrixCompleted: true})} update={this.props.update} />
        :
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
        }
      </Paper>
    );
  }

  getData = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    const company_id = this.state.user.company_id;
    let request1 = connection.get(routes.chooseFilters(company_id))
    let request2 = connection.get(routes.getCurrentStage(company_id))
    Promise.all([request1, request2])
    .then((response) => {
      this.props.update(response[0].data,"");
      this.setState({
        error: false,
        loading: false,
        choices: response[0].data,
        currentStage: response[1].data[response[1].data.length - 1].stage,
      }, this.checkMatrixProgress);
    })
    .catch((error) => {
      console.log(error);
      this.setState({
        error: true,
        loading: false
      })
    });
  }

  checkMatrixProgress = () => {
    let complete = true;
    Object.entries(this.state.choices).forEach(([key, choice]) => {
      if(Array.isArray(choice)){
        if (choice.length <= 0){
          complete = false;
        }
      }
      else if (choice === ""){
        complete = false;
      }
    })
    this.setState({matrixCompleted: complete});
  }

  addMatrixData = (data) => {
    this.setState({matrixData: data})
  }
}

export default withCookies(Criterias);



// WEBPACK FOOTER //
// ./src/components/conventions/Criterias.js